$('.imperial input, .imperial select').change(function(){ lhs(); })
$('.imperial input').keyup(function(){ lhs(); })
$('.metric select').change(function(){ lhs(); })
$('.metric input').keyup(function(){ rhs(); })

function lhs(){
	var a = $(".imperial input").val();
  	var b = $(".imperial select").val();
  	var c = $(".metric select").val();
// 	console.log(a,b,c, "LHS");
  	if(b=='Inches' && c=='Millimetres'){ $('.metric input').val((a*25.4).toFixed(1)); }
  	if(b=='Inches' && c=='Centimetres'){ $('.metric input').val((a*2.54).toFixed(1)); }
  	if(b=='Inches' && c=='Metres'){ $('.metric input').val((a/39.37).toFixed(3)); }
  
  	if(b=='Feet' && c=='Millimetres'){ $('.metric input').val((a*305).toFixed(1)); }
  	if(b=='Feet' && c=='Centimetres'){ $('.metric input').val((a*30.48).toFixed(1)); }
  	if(b=='Feet' && c=='Metres'){ $('.metric input').val((a*3.281).toFixed(3)); }
  
  	if(b=='Yards' && c=='Millimetres'){ $('.metric input').val((a*914).toFixed(1)); }
  	if(b=='Yards' && c=='Centimetres'){ $('.metric input').val((a*91.44).toFixed(1)); }
  	if(b=='Yards' && c=='Metres'){ $('.metric input').val((a/1.094).toFixed(3)); }
}

function rhs(){
	var a = $(".metric input").val();
  	var b = $(".imperial select").val();
  	var c = $(".metric select").val();
// 	console.log(a,b,c, "RHS");
  	if(b=='Inches' && c=='Millimetres'){ $('.imperial input').val((a/25.4).toFixed(3)); }
  	if(b=='Feet' && c=='Millimetres'){ $('.imperial input').val((a/305).toFixed(3)); }
  	if(b=='Yards' && c=='Millimetres'){ $('.imperial input').val((a/914).toFixed(3)); }
  
  	if(b=='Inches' && c=='Centimetres'){ $('.imperial input').val((a/2.54).toFixed(3)); }
  	if(b=='Feet' && c=='Centimetres'){ $('.imperial input').val((a/30.48).toFixed(3)); }
  	if(b=='Yards' && c=='Centimetres'){ $('.imperial input').val((a/91.44).toFixed(3)); }
  
  	if(b=='Inches' && c=='Metres'){ $('.imperial input').val((a*39.37).toFixed(3)); }
  	if(b=='Feet' && c=='Metres'){ $('.imperial input').val((a*3.281).toFixed(3)); }
  	if(b=='Yards' && c=='Metres'){ $('.imperial input').val((a*1.094).toFixed(3)); }
}